<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="buttonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>
                Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllCustomerCreditBalanceReport()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.month"
                    label="Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.month"
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.saleTeamId"
                :items="saleTeamList"
                label="Sale Team"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.accountIds"
                :items="selectedAccountList"
                label="Account"
                @click="showAccounts()"
                item-text="accName"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="customerCreditBalanceReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
            >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn color="primary" @click.stop="onShowDetail(props.item)">
                  Detail
                </v-btn>
              </td>
              <td>{{ props.item.accountCode }}</td>
              <td>{{ props.item.accountName }}</td>
              <td>{{ props.item.saleTeam }}</td>
              <td style="text-align: right">
                {{ props.item.openingBalance | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditSaleAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditCollectionAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.discount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.delivery | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.saleReturn | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.journalAdjustment | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.closingBalance | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- detail dialog -->
    <v-dialog v-model="showDetailDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-text>
          <v-flex xs12>
            <v-card>
              <div>
                <span style="padding-left: 20px; font-weight: bold">
                  Month:
                </span>
                <v-chip style="font-weight: bold">
                  <span>{{ headerObj.month }}</span>
                </v-chip>
                <span style="padding-left: 20px; font-weight: bold">
                  Shop:
                </span>
                <v-chip style="font-weight: bold">
                  <span> {{ headerObj.shopName }} </span>
                </v-chip>
                <span style="padding-left: 20px; font-weight: bold"
                  >Account Code:
                </span>
                <v-chip style="font-weight: bold">
                  <span> {{ headerObj.accountCode }} </span>
                </v-chip>

                <span style="padding-left: 20px; font-weight: bold"
                  >Account Name:
                </span>
                <v-chip style="font-weight: bold">
                  <span> {{ headerObj.accountName }} </span>
                </v-chip>
              </div>
              <div>
                <span style="padding-left: 20px; font-weight: bold">
                  Sale Team:
                </span>
                <v-chip style="font-weight: bold">
                  <span> {{ headerObj.saleTeam }} </span>
                </v-chip>
                <span style="padding-left: 20px; font-weight: bold">
                  Total Balance:
                </span>
                <v-chip style="font-weight: bold">
                  <span> {{ detailTotalBalance | decFormat(6) }} </span>
                </v-chip>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :must-sort="true"
                :headers="detailheaders"
                :items="customerCreditBalanceReportDetailList"
                class="elevation-1"
                :loading="showDetailListLoading"
                :total-items="totalDetailRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="detailpagination"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.dateInMilliSeconds | formatMsDate }}
                  </td>
                  <td>{{ props.item.issueNo }}</td>
                  <td>{{ props.item.shopName }}</td>
                  <td>{{ props.item.remark }}</td>
                  <td style="text-align: right">
                    {{ props.item.amount | decFormat(6) }}
                  </td>
                  <td style="text-align: right">
                    {{ props.item.balance | decFormat(6) }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <multi-select-account-dialog
      :showDialog="showAccountDialog"
      :params="{ isParent: false, status: 'ACTIVE', accountheadId: '', type: '' }"
      @close="closeAccountDialog"
    ></multi-select-account-dialog>
  </v-container>
</template>

<script>
import { customerCreditBalanceReportService } from "../../services/customer-credit-balance-report-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { saleTeamService } from "../../services/sale-team-service";
import MultiSelectAccountDialog from "../dialogs/MultiSelectAccountDialog.vue";

export default {
  name: "CustomerCreditBalanceReport",

  components: { MultiSelectAccountDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showDetailListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "General Reports",
        disabled: true,
      },
      {
        text: "Customer Credit Balance Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", align: "center", sortable: false },
      { text: "Account Code", sortable: false },
      { text: "Account Name", sortable: false },
      { text: "Sale Team", sortable: false },
      { text: "Opening Balance", sortable: false },
      { text: "Credit Sale Amount", sortable: false },
      { text: "Credit Collection Amount", sortable: false },
      { text: "Discount", sortable: false },
      { text: "Delivery", sortable: false },
      { text: "Sale Return", sortable: false },
      { text: "Journal Adjustment", sortable: false },
      { text: "Closing Balance", sortable: false },
    ],
    detailheaders: [
      { text: "Date", align: "left", sortable: false },
      { text: "Issue No", align: "left", sortable: false },
      { text: "Shop Name", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Amount", sortable: false },
      { text: "Balance", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0,
    },
    detailpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0,
    },
    customerCreditBalanceReportList: [],
    customerCreditBalanceReportDetailList: [],
    totalRows: 0,
    totalDetailRows: 0,
    queryParams: {
      month: commonService.formatDate(new Date(), "YYYY-MM"),
      shopId: "",
      saleTeamId: "",
      accountIds: "",
    },
    detailQueryParams: {
      month: "",
      shopId: "",
      accountId: "",
    },
    showDetailDialog: false,
    shopList: [],
    saleTeamList: [],
    headerObj: {
      month: "",
      shopName: "",
      accountCode: "",
      accountName: "",
      saleTeam: "",
    },
    detailTotalBalance: 0,
    clonequeryParams: new Object(),
    findAll: { id: "", name: "----All----" },

    showAccountDialog: false,
    selectedAccountList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getCustomerCreditBalanceReport();
      },
      deep: true,
    },
    detailpagination: {
      handler() {},
      deep: true,
    },
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.month) {
      this.queryParams.month = this.$route.query.month;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.saleTeamId) {
      this.queryParams.saleTeamId = this.$route.query.saleTeamId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getActiveSaleTeams();
    this.getAllShop().then(() => {
      this.onSearch();
    });
  },
  methods: {
    getAllShop() {
      return shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(this.findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveSaleTeams() {
      saleTeamService
        .getSaleTeamsByStatus("ACTIVE")
        .then((res) => {
          this.saleTeamList = res.data;
          this.saleTeamList.unshift({ id: "0", name: "---No Sale Team---" });
          this.saleTeamList.unshift(this.findAll);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "customer-credit-balance-report",
        query: this.queryParams,
      });
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      this.getCustomerCreditBalanceReport();
      this.prepareDetailParams();
    },
    getCustomerCreditBalanceReport() {
      this.showListLoading = true;
      customerCreditBalanceReportService
        .getCustomerCreditBalanceReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this.customerCreditBalanceReportList =
              res.data.customerCreditBalanceReportList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    prepareDetailParams() {
      let shop = commonService.search(
        "id",
        this.clonequeryParams.shopId,
        this.shopList
      );
      this.headerObj.shopName = shop.name;
      this.headerObj.month = this.clonequeryParams.month;
      this.detailQueryParams.month = this.clonequeryParams.month;
      this.detailQueryParams.shopId = this.clonequeryParams.shopId;
    },
    onShowDetail(item) {
      this.detailQueryParams.accountId = item.accountId;
      this.headerObj.accountCode = item.accountCode;
      this.headerObj.accountName = item.accountName;
      this.headerObj.saleTeam = item.saleTeam ? item.saleTeam : "No Sale Team";
      this.getCustomerCreditBalanceReportDetail();
      this.showDetailDialog = !this.showDetailDialog;
    },
    getCustomerCreditBalanceReportDetail() {
      this.showDetailListLoading = true;
      customerCreditBalanceReportService
        .getCustomerCreditBalanceReportDetail(
          this.detailQueryParams,
          this.detailpagination.page,
          this.detailpagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this.customerCreditBalanceReportDetailList =
              res.data.customerCreditBalanceReportDetailList;
            this.detailTotalBalance = res.data.totalBalance;
            this.totalDetailRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showDetailListLoading = false;
        });
    },
    exportAllCustomerCreditBalanceReport() {
      this.buttonLoading = true;
      customerCreditBalanceReportService
        .exportCustomerCreditBalanceReportExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },

    showAccounts() {
      this.showAccountDialog = true;
    },

    closeAccountDialog(selectedAccountList) {
      this.showAccountDialog = false;
      this.queryParams.accountIds = [];
      this.selectedAccountList = selectedAccountList;

      console.log(selectedAccountList);
      this.selectedAccountList.forEach((element) => {
        if (!this.queryParams.accountIds.includes(element.id))
          this.queryParams.accountIds.push(element.id);
      });
    },
  },
};
</script>